// INDEX PAGE
export type TMenuStatus = 'ACTIVE' | 'INACTIVE' | 'SOLD_OUT';

export interface IMenuItem {
  id?: string;
  name?: string;
  intro?: string;
  categoryId?: number;
  category?: string;
  categorySeq?: number;
  priority?: number;
  price?: number;
  sellPrice?: number;
  imageThumbnail?: string | null;
  status?: TMenuStatus;
}

export interface IMenuCategories {
  categoryId?: number;
  priority?: number;
  categoryName?: string;
}

export interface IImageInfo {
  width?: number;
  height?: number;
  url?: string;
}

export interface IUsingCompany {
  companyName?: string;
  priceType?: 'RATE' | 'FIXED';
  menuPrice?: number;
  menuSalesPrice?: number;
  menuSupplyPrice?: number;
}

export interface IMenuDetailData {
  id?: string;
  name?: string;
  intro?: string;
  categoryId?: number;
  category?: string;
  categorySeq?: number;
  priority?: number;
  price?: number;
  sellPrice?: number;
  status?: TMenuStatus;
  imageThumbnail?: IImageInfo | null;
  detailImage?: IImageInfo | null;
  usingCompanies?: IUsingCompany[];
}
// MENU CARD PAGE
export interface IPresignedUrlResponse {
  preSignedUrl: string;
  uploadedFileUrl: string;
}

export interface TImageData {
  file: File | null;
  previewURL: string;
}

// MENU UPDATE MODAL PAGE
export const menuStatusItems: { label: string; value: TMenuStatus }[] = [
  { label: '판매중', value: 'ACTIVE' },
  { label: '판매종료', value: 'INACTIVE' },
  { label: '일시품절', value: 'SOLD_OUT' }
];

export type TImageType = 'FOODMALL_IMAGE_THUMBNAIL' | 'FOODMALL_DETAIL_IMAGE' | 'IMAGE_THUMBNAIL';

export interface IImageState {
  url: string | null;
  file: File | null;
}
